import {
  blue,
  green,
  lightGreen,
  purple,
  red,
  yellow,
} from "@mui/material/colors";

const statusProps = [
  {
    status: "PRE_ORDER",
    color: "yellow",
    text: "",
    variant: "warning",
    backgroundColor: "white",
    textColor: "white",
  },
  {
    status: "WAITING_AUTHORIZATION",
    color: "yellow",
    text: "Aguardando autorização",
    variant: "warning",
    backgroundColor: yellow[100],
    textColor: yellow[800],
  },
  {
    status: "AUTHORIZATION_FAILED",
    color: "red",
    text: "Autorização falhou",
    variant: "danger",
    backgroundColor: red[100],
    textColor: red[800],
  },
  {
    status: "SEARCHING_DELIVERY",
    color: "blue",
    text: "Pesquisando entregador",
    variant: "warning",
    backgroundColor: purple[100],
    textColor: purple[800],
  },
  {
    status: "WAITING_COLLECT",
    color: "yellow",
    text: "Aguardando coleta",
    variant: "primary",
    backgroundColor: lightGreen[100],
    textColor: lightGreen[800],
  },
  {
    status: "WAITING_PAYMENT",
    color: "yellow",
    text: "Aguardando pagamento",
    variant: "primary",
    backgroundColor: yellow[100],
    textColor: yellow[800],
  },
  {
    status: "WITH_DELIVERY",
    color: "orange",
    text: "Coletado",
    variant: "info",
    backgroundColor: blue[100],
    textColor: blue[800],
  },
  {
    status: "IN_ROUTE",
    color: "red",
    text: "Em trânsito",
    variant: "info",
    backgroundColor: blue[100],
    textColor: blue[800],
  },
  {
    status: "FINISHED",
    color: "green",
    text: "Entregue",
    variant: "success",
    backgroundColor: green[100],
    textColor: green[800],
  },
  {
    status: "CANCELED",
    color: "yellow",
    text: "Cancelado",
    variant: "danger",
    backgroundColor: red[100],
    textColor: red[800],
  },
];

export default statusProps;
